export default __webpack_public_path__ + "static/media/Might of the Serpent Men.aa24b2c6.jpg";